import { Component, EventEmitter, Input, Output } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { ModalBase } from '../../base/modal-base/modal-base.component';

@Component({
    selector: 'delete-confirm-modal',
    templateUrl: 'delete-confirm-modal.html',
    standalone: false,
})
export class DeleteConfirmModal extends ModalBase {
    constructor(protected override spinnerService: NgxSpinnerService) {
        super(spinnerService);
    }

    @Output() onConfirmEvent: EventEmitter<{
        confirm: boolean;
        parameter: any;
    }> = new EventEmitter();

    public deleteItemId: number | string;

    public openModal(id: number | string): void {
        this.deleteItemId = id;
        this.open();
    }

    @Input()
    public modalId: string;

    @Input()
    public title: string;

    @Input()
    public question: string;

    public ngAfterViewInit(): void {
        this.init();
    }

    public btnConfirm(): void {
        this.onConfirmEvent.emit({
            confirm: true,
            parameter: this.deleteItemId,
        });
    }

    public btnReject(): void {
        this.onConfirmEvent.emit({
            confirm: false,
            parameter: this.deleteItemId,
        });
        this.close();
    }
}
